export default function sortData(data, column, ascending = true) {
    return data?.sort((a, b) => {
        const aValue = a[column];
        const bValue = b[column];
        let comparison = 0;
        if (aValue > bValue) {
            comparison = 1;
        } else if (aValue < bValue) {
            comparison = -1;
        }
        return ascending ? comparison : -comparison;
    });
}
